/**
 * Class thực hiện xử lý Log và AuditingLog của hệ thống
 * @author DNThang - 28.08.2019
 */
const LogLevel = Object.freeze({
  Trace: 0,
  Info: 1,
  Warn: 2,
  Error: 3,
})
const isDevelopment = () => process.env.NODE_ENV === 'development'

class LogUtil {
  // #region Log

  /**
   * Xử lý lỗi trên client
   * @author DNThang - 03.07.2019
   */
  handleException (exp) {
    if (exp && window.__env.systemConfig.logLevel > LogLevel.Warn) {
      if (exp instanceof String) {
        console.error(exp)
      } else if (exp.request && exp.request.responseText) {
        console.error(exp.request.responseText)
      } else if (exp.stack) {
        console.error(exp.stack)
      }
    }
  }

  /**
   * Xử lý lưu lại thông tin phục vụ tracking môi trường dev
   * @param {String} msg Thông tin cần log
   * @author DNThang - 03.07.2019
   */
  debugLogging (msg) {
    if (msg && isDevelopment()) {
      console.debug(msg)
    }
  }

  /**
   * Xử lý lưu lại thông tin phục vụ tracking
   * @param {String} msg Thông tin cần log
   * @author DNThang - 03.07.2019
   */
  traceLogging (msg) {
    if (msg && LogLevel.Trace >= window.__env.systemConfig.logLevel) {
      console.trace(msg)
    }
  }

  /**
   * Xử lý lưu lại thông tin phục vụ tracking
   * @param {String} msg Thông tin cần log
   * @author DNThang - 03.07.2019
   */
  infoLogging (msg) {
    if (msg && LogLevel.Info >= window.__env.systemConfig.logLevel) {
      console.info(msg)
    }
  }

  /**
   * Xử lý lưu lại thông tin phục vụ tracking
   * @param {String} msg Thông tin cần log
   * @author DNThang - 26.07.2019
   */
  warnLogging (msg) {
    if (msg && LogLevel.Warn >= window.__env.systemConfig.logLevel) {
      console.warn(msg)
    }
  }

  /**
   * @description Log error
   * @param {*} msg
   */
  errorLogging (logger, msg) {
    if (msg && LogLevel.Error >= window.__env.systemConfig.logLevel) {
      console.error(logger, msg)
    }
  }

  /**
   * func cảnh báo DEV
   * @param {*} msg
   * @author NCThanh1 15.5.2020
   */
  alertDev (msg) {
    if (isDevelopment() && msg) {
      alert(msg)
    }
  }

  // #endregion Log
}

export default new LogUtil()
